import { getStatusPageUrl } from "@/lib/urls";

import type { FeatureSlug } from "./features";

/** The public sample production "See a show prepped" opens. No login. */
export const SAMPLE_PRODUCTION_PATH = "/sample-production";

export type NavItem = {
  labelKey: string;
  href: string;
  /** When true (or href is absolute http/https), render as an external anchor. */
  external?: boolean;
};

export type FeatureNavItem = {
  slug: FeatureSlug;
  labelKey: string;
};

export type FeatureNavGroup = {
  labelKey?: string;
  items: FeatureNavItem[];
};

export const featureNavGroups: FeatureNavGroup[] = [
  {
    items: [
      { slug: "script", labelKey: "nav.featuresScript" },
      { slug: "schedule", labelKey: "nav.featuresSchedule" },
      { slug: "budgeting", labelKey: "nav.featuresBudgeting" },
    ],
  },
];

export const featureNavItems: FeatureNavItem[] = featureNavGroups.flatMap(
  (group) => group.items,
);

/**
 * Links after the "What it does" features menu. MCP, Security and FAQ live in
 * the footer only.
 */
export const primaryNav: NavItem[] = [
  { labelKey: "nav.seeShowPrepped", href: SAMPLE_PRODUCTION_PATH },
  { labelKey: "nav.pricing", href: "/pricing" },
  { labelKey: "nav.forStudios", href: "/enterprise" },
];

export const footerProductLinks: NavItem[] = [
  { labelKey: "nav.features", href: "/features" },
  { labelKey: "nav.developers", href: "/developers" },
  { labelKey: "nav.mcp", href: "/mcp" },
  { labelKey: "nav.pricing", href: "/pricing" },
  { labelKey: "nav.security", href: "/security" },
  { labelKey: "nav.enterprise", href: "/enterprise" },
  { labelKey: "nav.alternatives", href: "/compare" },
];

export const footerCompanyLinks: NavItem[] = [
  { labelKey: "footer.about", href: "/about" },
  { labelKey: "footer.blog", href: "/blog" },
  { labelKey: "footer.faq", href: "/faq" },
  { labelKey: "nav.contact", href: "/contact" },
  { labelKey: "nav.resources", href: "/resources" },
  { labelKey: "footer.status", href: getStatusPageUrl(), external: true },
];

export const footerLegalLinks: NavItem[] = [
  { labelKey: "footer.privacy", href: "/privacy" },
  { labelKey: "footer.terms", href: "/terms" },
];
